import { Activity } from './Activity';

export type Module = {
    id: string;
    title: string;
    description: string;
    moduleType: ModuleType;
    dateCreated: string;
    dateUpdated: string;
    category: string;
    order: number;
    activities: Activity[];
};

export enum ModuleType {
    LEARNER_LED = 'LEARNER_LED',
    PRESENTATION = 'PRESENTATION',
}
